<template>
  <div class="new-order-notify-rule">
    <van-nav-bar
      :left-arrow="true"
      left-text="返回"
      :title="ruleId ? '编辑规则' : '新增规则'"
      fixed
      :placeholder="true"
      @click-left="goBack"
    >
      <van-icon v-if="ruleId" name="delete" slot="right" @click="deleteRule" />
    </van-nav-bar>
    <div class="page-body">
      <van-cell-group class="card-section first-section">
        <van-cell title="规则名称" class="form-cell">
          <template slot="title">
            <span class="cell-label">规则名称</span>
            <span class="cell-required">*</span>
          </template>
          <van-field
            v-model="ruleInfo.name"
            placeholder="请输入规则名称"
            rows="1"
            right
            clearable
            borderless
            class="cell-input"
          />
        </van-cell>
        <van-cell
          is-link
          :value="ruleInfo.gp_line_desc || '不限'"
          @click="showGplineSelect"
          :class="getGplineColorClass()"
        >
          <template slot="title">
            <span class="cell-label">院线</span>
          </template>
        </van-cell>
        <van-cell
          is-link
          :value="ruleInfo.province_desc || '不限'"
          @click="showProvinceSelect"
          :class="getProvinceColorClass()"
        >
          <template slot="title">
            <span class="cell-label">省份</span>
          </template>
        </van-cell>
        <van-cell
          is-link
          :value="ruleInfo.city_desc || '不限'"
          @click="showCitySelect"
          :class="getCityColorClass()"
        >
          <template slot="title">
            <span class="cell-label">城市</span>
          </template>
        </van-cell>
        <van-cell
          is-link
          :value="ruleInfo.cinema_desc || '不限'"
          @click="showCinemaSelect"
          :class="getCinemaColorClass()"
        >
          <template slot="title">
            <span class="cell-label">影院</span>
          </template>
        </van-cell>
        <van-cell
          is-link
          :value="ruleInfo.hall_desc || '不限'"
          @click="showHallSelect"
          :class="getHallColorClass()"
        >
          <template slot="title">
            <span class="cell-label">影厅</span>
          </template>
        </van-cell>
        <van-cell
          is-link
          :value="ruleInfo.movie_desc || '不限'"
          @click="showMovieSelect"
          :class="getMovieColorClass()"
        >
          <template slot="title">
            <span class="cell-label">电影</span>
          </template>
        </van-cell>
      </van-cell-group>

      <div class="section-title">时间与场次</div>
      <van-cell-group class="card-section">
        <van-cell class="custom-cell form-cell range-cell">
          <template slot="title">
            <span class="cell-label">放映日期</span>
          </template>
          <van-row class="range-row">
            <van-field
              v-model="ruleInfo.begin_date"
              placeholder="开始"
              rows="1"
              clearable
              class="range-field"
              @click.native="changeDate(1)"
            />
            <span class="range-sep" />
            <van-field
              v-model="ruleInfo.end_date"
              placeholder="结束"
              rows="1"
              clearable
              class="range-field"
              @click.native="changeDate(2)"
            />
          </van-row>
        </van-cell>
        <van-cell class="custom-cell form-cell range-cell">
          <template slot="title">
            <span class="cell-label">放映时间</span>
          </template>
          <van-row class="range-row">
            <van-field
              v-model="ruleInfo.begin_time"
              placeholder="开始"
              rows="1"
              clearable
              class="range-field"
              @click.native="changeTime(1)"
            />
            <span class="range-sep" />
            <van-field
              v-model="ruleInfo.end_time"
              placeholder="结束"
              rows="1"
              clearable
              class="range-field"
              @click.native="changeTime(2)"
            />
          </van-row>
        </van-cell>
      <van-cell is-link :value="ruleInfo.week_desc || '设置包含星期'" @click="showWeekSelect">
        <template slot="title">
          <span class="cell-label">包含星期</span>
        </template>
      </van-cell>
    </van-cell-group>

      <div class="section-title">其他条件</div>
      <van-cell-group class="card-section other-condition-section">
      <van-cell reverse-color class="ticket-count-cell">
        <template slot="title">
          <span class="cell-label">票数</span>
        </template>
        <van-checkbox-group
          v-model="ruleInfo.ticket_num"
          @change="handleTicketCountChange"
          class="ticket-group"
        >
          <van-checkbox :name="0" class="ticket-opt" @click.native="lastClick(0)">全部</van-checkbox>
          <van-checkbox :name="1" class="ticket-opt" @click.native="lastClick(1)">1张</van-checkbox>
          <van-checkbox :name="2" class="ticket-opt" @click.native="lastClick(2)">2张</van-checkbox>
          <van-checkbox :name="3" class="ticket-opt" @click.native="lastClick(3)">3张</van-checkbox>
          <van-checkbox :name="4" class="ticket-opt" @click.native="lastClick(4)">4张</van-checkbox>
        </van-checkbox-group>
      </van-cell>
      <van-cell reverse-color class="couple-seat-cell">
        <template slot="title">
          <span class="cell-label">情侣座</span>
        </template>
        <van-radio-group v-model="ruleInfo.seat_tag" class="seat-radio-group">
          <van-radio :name="'1'">包含情侣座</van-radio>
          <van-radio :name="'2'">不含情侣座</van-radio>
        </van-radio-group>
      </van-cell>
      <van-cell class="form-cell status-cell">
        <template slot="title">
          <span class="cell-label">启动状态</span>
        </template>
        <van-switch :value="ruleInfo.status === 1" @input="setStatus" />
      </van-cell>
    </van-cell-group>

      <div class="save-wrap">
        <van-button round type="danger" block class="save-btn" @click="saveRule">保存条件</van-button>
      </div>
    </div>

    <!-- 院线弹窗 -->
    <van-popup v-model="selectGpline" position="bottom">
      <div style="background-color: #f5f5f5;padding: 15px;">
        <van-row style="display: flex;justify-content: center;align-items: center;">
          <span style="font-size: 16px;font-weight: bold;">选择院线</span>
        </van-row>
      </div>
      <van-row>
        <van-search
          v-model="searchText"
          placeholder="请输入品牌名"
          style="width: 100%;"
          @clear="clearGplineClick"
        >
          <template #right-icon>
            <van-button size="small" type="info" round @click="searchGplineClick">搜索</van-button>
          </template>
        </van-search>
      </van-row>
      <div style="height: 320px; overflow: scroll;padding: 10px 10px 60px 10px;">
        <div v-for="(gpline, index) in filterGplineList" :key="index" class="custom-checkbox" :class="{ 'checked': gpline.checked }" @click="gplineCheck(index)" style="margin: 8px;">
          {{ gpline.label }}
        </div>
      </div>
      <div class="popup-bottom">
        <span class="popup-bottom-count">已选择 <em class="count-link" @click="selectCount && showSelectedGplineList()">{{ selectCount }}</em> 个院线</span>
        <span class="popup-bottom-actions">
          <van-button plain size="small" @click="resetGpline">重置</van-button>
          <van-button type="danger" size="small" @click="saveGplineExclude">确认排除</van-button>
          <van-button type="primary" size="small" @click="saveGpline">确认选择</van-button>
        </span>
      </div>
    </van-popup>

    <!-- 省份弹窗 -->
    <van-popup v-model="selectProvince" position="bottom" class="province-popup">
      <div class="popup-header">
        <span class="popup-title">选择省份</span>
      </div>
      <div class="popup-list-wrap">
        <van-cell-group>
          <van-cell
            v-for="(province, index) in filterProvinceList"
            :key="index"
            :title="province.label"
            @click="provinceCheck(index)"
          >
            <template #right-icon>
              <van-checkbox :value="province.checked" shape="square" @click.native.prevent />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="popup-bottom">
        <span class="popup-bottom-count">已选择 <em class="count-link" @click="selectCount && showSelectedProvinceList()">{{ selectCount }}</em> 个省份</span>
        <span class="popup-bottom-actions">
          <van-button plain size="small" @click="resetProvince">重置</van-button>
          <van-button type="danger" size="small" @click="saveProvinceExclude">确认排除</van-button>
          <van-button type="primary" size="small" @click="saveProvince">确认选择</van-button>
        </span>
      </div>
    </van-popup>

    <!-- 城市弹窗 -->
    <van-popup v-model="selectCity" position="bottom">
      <div class="popup-header">
        <span class="popup-title">选择城市</span>
      </div>
      <van-search
        v-model="searchCityText"
        placeholder="请输入城市"
        class="city-popup-search"
      >
        <template slot="right-icon">
          <span class="city-search-actions">
            <van-icon v-if="searchCityText" name="clear" @click="clearCitySearch" />
            <van-button size="small" type="info" round @click="searchCityClick">搜索</van-button>
          </span>
        </template>
      </van-search>
      <van-tree-select
        class="city-popup-tree"
        :items="cityTreeNavItems"
        :main-active-index.sync="activeIndex"
        style="height: 360px; padding: 10px;"
      >
        <template slot="content">
          <van-row v-for="item in displayedCityList" :key="item.city.city_code" class="city-select-row">
            <van-cell
              :title="getCityItemTitle(item)"
              class="cell-with-margin"
              @click="toggleCityByItem(item)"
            >
              <template #right-icon>
                <van-checkbox :value="item.city.checked" shape="square" @click.native.prevent />
              </template>
            </van-cell>
          </van-row>
        </template>
      </van-tree-select>
      <div class="popup-bottom">
        <span class="popup-bottom-count">已选择 <em class="count-link" @click="selectCount && showSelectedCityList()">{{ selectCount }}</em> 个城市</span>
        <span class="popup-bottom-actions">
          <van-button plain size="small" @click="resetCity">重置</van-button>
          <van-button type="danger" size="small" @click="saveCityExclude">确认排除</van-button>
          <van-button type="primary" size="small" @click="saveCity">确认选择</van-button>
        </span>
      </div>
    </van-popup>

    <!-- 影院弹窗 -->
    <van-popup v-model="selectCinema" position="bottom" style="height: 80%;" class="cinema-popup">
      <div class="cinema-popup-content">
        <div class="popup-header">
          <span class="popup-title">选择影院</span>
        </div>
        <van-search v-model="searchCinemaText" placeholder="请输入影院名" class="cinema-popup-search">
          <template slot="right-icon">
            <span class="cinema-search-actions">
              <van-icon v-if="searchCinemaText" name="clear" @click="clearCinemaSearch" />
              <van-button size="small" type="info" round @click="searchCinemaClick">搜索</van-button>
            </span>
          </template>
        </van-search>
        <div class="popup-list-wrap cinema-list-wrap">
          <van-cell
            v-for="(item, index) in filterCinemaList"
            :key="item.id"
            :title="(item.city_name ? item.city_name + ' · ' : '') + item.name"
            :label="item.address"
            @click="toggleCinema(index)"
          >
            <template slot="right-icon">
              <van-checkbox :value="item.checked" shape="square" @click.native.prevent />
            </template>
          </van-cell>
        </div>
        <div class="popup-bottom">
        <span class="popup-bottom-count">已选择 <em class="count-link" @click="selectCinemaCount && showSelectedCinemaList()">{{ selectCinemaCount }}</em> 个影院</span>
        <span class="popup-bottom-actions">
          <van-button plain size="small" @click="resetCinema">重置</van-button>
          <van-button type="danger" size="small" @click="saveCinemaExclude">确认排除</van-button>
          <van-button type="primary" size="small" @click="saveCinema">确认选择</van-button>
        </span>
        </div>
      </div>
    </van-popup>

    <!-- 影厅弹窗 -->
    <van-popup v-model="selectHall" position="bottom" class="hall-popup">
      <div class="popup-header">
        <span class="popup-title">选择影厅</span>
      </div>
      <div class="popup-list-wrap">
        <van-cell-group>
          <van-cell
            v-for="(hall, index) in filterHallList"
            :key="index"
            :title="hall.label"
            @click="hallCheck(index)"
          >
            <template #right-icon>
              <van-checkbox :value="hall.checked" shape="square" @click.native.prevent />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="popup-bottom">
        <span class="popup-bottom-count">已选择 <em class="count-link" @click="selectCount && showSelectedHallList()">{{ selectCount }}</em> 个影厅</span>
        <span class="popup-bottom-actions">
          <van-button plain size="small" @click="resetHall">重置</van-button>
          <van-button type="danger" size="small" @click="saveHallExclude">确认排除</van-button>
          <van-button type="primary" size="small" @click="saveHall">确认选择</van-button>
        </span>
      </div>
    </van-popup>

    <!-- 电影弹窗 -->
    <van-popup v-model="selectMovie" position="bottom">
      <div style="background-color: #f5f5f5;padding: 15px;">
        <span style="font-size: 16px;font-weight: bold;">选择电影</span>
      </div>
      <van-search v-model="searchText" placeholder="搜索电影" @search="searchMovieClick" />
      <div style="height: 320px; overflow: scroll;padding: 10px 10px 60px 10px;">
        <div v-for="(movie, index) in filterMovieList" :key="index" class="custom-checkbox" :class="{ 'checked': movie.checked }" @click="movieCheck(index)" style="margin: 8px;">
          {{ movie.label }}
        </div>
      </div>
      <div class="popup-bottom">
        <span class="popup-bottom-count">已选择 <em class="count-link" @click="selectCount && showSelectedMovieList()">{{ selectCount }}</em> 个电影</span>
        <span class="popup-bottom-actions">
          <van-button plain size="small" @click="resetMovie">重置</van-button>
          <van-button type="danger" size="small" @click="saveMovieExclude">确认排除</van-button>
          <van-button type="primary" size="small" @click="saveMovie">确认选择</van-button>
        </span>
      </div>
    </van-popup>

    <!-- 星期弹窗 -->
    <van-popup v-model="selectWeek" position="bottom">
      <div style="background-color: #f5f5f5;padding: 15px;">
        <span style="font-size: 16px;font-weight: bold;">包含星期</span>
      </div>
      <div style="height: 320px; overflow: scroll;padding: 10px 10px 60px 10px;">
        <div v-for="(week, index) in filterWeekList" :key="index" class="custom-checkbox" :class="{ 'checked': week.checked }" @click="weekCheck(index)" style="margin: 8px;">
          {{ week.name }}
        </div>
      </div>
      <div class="popup-bottom">
        <span class="popup-bottom-count">已选择 <em class="count-link" @click="selectCount && showSelectedWeekList()">{{ selectCount }}</em> 个</span>
        <van-button type="primary" size="small" @click="saveWeek">确认</van-button>
      </div>
    </van-popup>

    <!-- 已选内容列表弹框 -->
    <van-popup v-model="showSelectedList" position="bottom" round class="selected-list-popup">
      <div class="popup-header">
        <span class="popup-title">{{ selectedListTitle }}</span>
      </div>
      <div class="selected-list-wrap">
        <van-cell v-for="(item, idx) in selectedListItems" :key="idx" :title="item.text" :label="item.sub" />
        <div v-if="selectedListItems.length === 0" class="selected-list-empty">暂无已选内容</div>
      </div>
    </van-popup>

    <!-- 日期选择 -->
    <van-popup v-model="selectDate" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @confirm="dateCheck"
        @cancel="selectDate = false"
      />
    </van-popup>
    <!-- 时间选择 -->
    <van-popup v-model="selectTime" position="bottom">
      <van-datetime-picker
        v-model="currentTime"
        type="time"
        @confirm="timeCheck"
        @cancel="selectTime = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Api from '@/api-service/requests/api-request'
import { Dialog } from 'vant'

const SCOPE_TYPE_ALL = 1
const SCOPE_TYPE_INCLUDE = 2
const SCOPE_TYPE_EXCLUDE = 3

export default {
  name: 'NewOrderNotifyRule',
  data() {
    return {
      ruleId: null,
      copyId: null,
      ruleInfo: {
        name: '',
        status: 1,
        gp_line_scope_type: SCOPE_TYPE_ALL,
        gp_line_scope: [],
        gp_line_desc: '不限',
        province_scope_type: SCOPE_TYPE_ALL,
        province_scope: [],
        province_desc: '不限',
        city_scope_type: SCOPE_TYPE_ALL,
        city_scope: [],
        city_desc: '不限',
        cinema_scope_type: SCOPE_TYPE_ALL,
        cinema_scope: [],
        cinema_desc: '不限',
        hall_scope_type: SCOPE_TYPE_ALL,
        hall_scope: [],
        hall_desc: '不限',
        movie_scope_type: SCOPE_TYPE_ALL,
        movie_scope: [],
        movie_desc: '不限',
        begin_date: '',
        end_date: '',
        begin_time: '',
        end_time: '',
        week_days: [],
        week_desc: '设置包含星期',
        ticket_num: [0],
        seat_tag: '1',
      },
      searchText: '',
      selectProvince: false,
      selectCity: false,
      selectGpline: false,
      selectCinema: false,
      selectHall: false,
      selectMovie: false,
      selectWeek: false,
      selectDate: false,
      selectTime: false,
      activeIndex: 0,
      selectCount: 0,
      currentDate: new Date(),
      currentTime: '00:00',
      src: 1,
      provinceList: [],
      filterProvinceList: [],
      cityList: [],
      filterCityList: [],
      searchCityText: '',
      searchCityCommitted: '',
      gpLineList: [],
      filterGplineList: [],
      cinemaList: [],
      filterCinemaList: [],
      selectCinemaList: [],
      selectCinemaCount: 0,
      searchCinemaText: '',
      defaultHallList: [],
      filterHallList: [],
      selectHallList: [],
      movieList: [],
      filterMovieList: [],
      weekList: [
        { label: '星期一', id: 1 },
        { label: '星期二', id: 2 },
        { label: '星期三', id: 3 },
        { label: '星期四', id: 4 },
        { label: '星期五', id: 5 },
        { label: '星期六', id: 6 },
        { label: '星期日', id: 7 },
      ],
      filterWeekList: [],
      selectWeekList: [],
      inited: false,
      showSelectedList: false,
      selectedListTitle: '',
      selectedListItems: [],
      lastChecked: null,
      /** 规则详情返回的已选影院列表 select_cinema，用于置顶展示 */
      cinemaScopeListFromDetail: [],
    }
  },
  created() {
    this.ruleId = this.$route.params.id ? parseInt(this.$route.params.id, 10) : null
    this.copyId = this.$route.query.copyId ? parseInt(this.$route.query.copyId, 10) : null
    if (!this.ruleInfo.ticket_num || this.ruleInfo.ticket_num.length === 0) {
      this.ruleInfo.ticket_num = [0]
    }
    this.getProvince()
    this.getGpline()
    this.getCinema()
    this.getHallList()
    this.getMovieList()
    if (this.ruleId) {
      this.fetchDetail()
    } else if (this.copyId) {
      this.fetchDetail(true)
    }
  },
  computed: {
    // 参考报价方案：右侧展示当前选中省份的完整城市列表（搜索仅重排省份，不筛右侧列表）
    displayedCityList() {
      const prov = this.filterCityList[this.activeIndex]
      const list = (prov && prov.city_list) ? prov.city_list : []
      return list.map(c => ({ city: c, provinceIndex: this.activeIndex }))
    },
    // 城市弹框左侧省份列表，已选城市的省份右侧显示红点
    cityTreeNavItems() {
      return (this.filterCityList || []).map(prov => ({
        ...prov,
        dot: (prov.city_list || []).some(c => c.checked),
      }))
    },
  },
  methods: {
    fetchDetail(isCopy) {
      const id = isCopy ? this.copyId : this.ruleId
      Api.getOrderNotifyConditionDetail({ id }).then(res => {
        const toNumArr = (arr) => (Array.isArray(arr) && arr.length ? arr.map((x) => Number(x)) : [])
        this.ruleInfo.name = res.name
        this.ruleInfo.status = res.status
        this.ruleInfo.gp_line_scope_type = res.gp_line_scope_type || SCOPE_TYPE_ALL
        this.ruleInfo.gp_line_scope = toNumArr(res.gp_line_scope)
        this.ruleInfo.province_scope_type = res.province_scope_type || SCOPE_TYPE_ALL
        this.ruleInfo.province_scope = toNumArr(res.province_scope)
        this.ruleInfo.city_scope_type = res.city_scope_type || SCOPE_TYPE_ALL
        this.ruleInfo.city_scope = toNumArr(res.city_scope)
        this.ruleInfo.cinema_scope_type = res.cinema_scope_type || SCOPE_TYPE_ALL
        this.ruleInfo.cinema_scope = toNumArr(res.cinema_scope)
        this.cinemaScopeListFromDetail = Array.isArray(res.select_cinema)
          ? res.select_cinema
          : (Array.isArray(res.cinema_scope_list) ? res.cinema_scope_list : [])
        this.ruleInfo.hall_scope_type = res.hall_scope_type || SCOPE_TYPE_ALL
        this.ruleInfo.hall_scope = Array.isArray(res.hall_scope) && res.hall_scope.length ? [...res.hall_scope] : []
        this.ruleInfo.movie_scope_type = res.movie_scope_type || SCOPE_TYPE_ALL
        this.ruleInfo.movie_scope = toNumArr(res.movie_scope)
        this.ruleInfo.seat_tag = res.seat_tag !== undefined && res.seat_tag !== null ? String(res.seat_tag) : '1'
        if (res.date_during != null && res.date_during !== '') {
          const arr = String(res.date_during).split(',')
          this.ruleInfo.begin_date = arr[0] || ''
          this.ruleInfo.end_date = arr[1] || ''
        } else {
          this.ruleInfo.begin_date = ''
          this.ruleInfo.end_date = ''
        }
        if (res.time_during != null && res.time_during !== '') {
          const arr = String(res.time_during).split(',')
          this.ruleInfo.begin_time = arr[0] || ''
          this.ruleInfo.end_time = arr[1] || ''
        } else {
          this.ruleInfo.begin_time = ''
          this.ruleInfo.end_time = ''
        }
        this.ruleInfo.week_days = Array.isArray(res.week_days) && res.week_days.length ? [...res.week_days] : []
        this.ruleInfo.week_desc = this.ruleInfo.week_days.length ? this.ruleInfo.week_days.join('、') : '设置包含星期'
        const ticketList = toNumArr(res.ticket_count_list)
        this.ruleInfo.ticket_num = ticketList.length ? ticketList : [0]
        this.buildScopeDesc()
        if (isCopy) {
          this.ruleId = null
          this.ruleInfo.name = (this.ruleInfo.name || '') + '(复制)'
        }
      })
    },
    buildScopeDesc() {
      if (this.ruleInfo.gp_line_scope && this.ruleInfo.gp_line_scope.length) {
        this.ruleInfo.gp_line_desc = this.ruleInfo.gp_line_scope_type === SCOPE_TYPE_EXCLUDE ? `已排除${this.ruleInfo.gp_line_scope.length}个院线` : `已选择${this.ruleInfo.gp_line_scope.length}个院线`
      } else {
        this.ruleInfo.gp_line_desc = '不限'
      }
      if (this.ruleInfo.province_scope && this.ruleInfo.province_scope.length) {
        this.ruleInfo.province_desc = this.ruleInfo.province_scope_type === SCOPE_TYPE_EXCLUDE ? `已排除${this.ruleInfo.province_scope.length}个省份` : `已包含${this.ruleInfo.province_scope.length}个省份`
      } else {
        this.ruleInfo.province_desc = '不限'
      }
      if (this.ruleInfo.city_scope && this.ruleInfo.city_scope.length) {
        this.ruleInfo.city_desc = this.ruleInfo.city_scope_type === SCOPE_TYPE_EXCLUDE ? `已排除${this.ruleInfo.city_scope.length}个城市` : `已包含${this.ruleInfo.city_scope.length}个城市`
      } else {
        this.ruleInfo.city_desc = '不限'
      }
      if (this.ruleInfo.cinema_scope && this.ruleInfo.cinema_scope.length) {
        this.ruleInfo.cinema_desc = this.ruleInfo.cinema_scope_type === SCOPE_TYPE_EXCLUDE ? `已排除${this.ruleInfo.cinema_scope.length}个影院` : `已包含${this.ruleInfo.cinema_scope.length}个影院`
      } else {
        this.ruleInfo.cinema_desc = '不限'
      }
      if (this.ruleInfo.hall_scope && this.ruleInfo.hall_scope.length) {
        this.ruleInfo.hall_desc = this.ruleInfo.hall_scope_type === SCOPE_TYPE_EXCLUDE ? `已排除${this.ruleInfo.hall_scope.length}个影厅` : `已包含${this.ruleInfo.hall_scope.length}个影厅`
      } else {
        this.ruleInfo.hall_desc = '不限'
      }
      if (this.ruleInfo.movie_scope && this.ruleInfo.movie_scope.length) {
        this.ruleInfo.movie_desc = this.ruleInfo.movie_scope_type === SCOPE_TYPE_EXCLUDE ? `已排除${this.ruleInfo.movie_scope.length}个电影` : `已包含${this.ruleInfo.movie_scope.length}个电影`
      } else {
        this.ruleInfo.movie_desc = '不限'
      }
    },
    getProvince() {
      Api.getProvinceCityList({}).then(res => {
        this.provinceList = (res.list || []).map(el => ({ label: el.name, value: el.id, checked: false }))
        this.cityList = res.list || []
        this.filterCityList = res.list || []
      })
    },
    getGpline() {
      Api.getGpLineList({}).then(res => {
        this.gpLineList = (res.list || []).map(el => ({ label: el.name, value: el.ID, checked: false }))
        this.filterGplineList = [...this.gpLineList]
      })
    },
    getCinema() {
      Api.getCinemaList({ page: 1, pageSize: 100 }).then(res => {
        this.cinemaList = (res.list || []).map(el => ({
          name: el.name,
          city_name: el.city_name,
          id: el.ID,
          address: el.address || el.addr || '',
          checked: false,
        }))
        this.filterCinemaList = [...this.cinemaList]
      })
    },
    getHallList() {
      Api.getDefaultHallList({}).then(res => {
        this.defaultHallList = (res || []).map(el => ({ name: el.name }))
      })
    },
    getMovieList() {
      Api.getMovieList({ pageSize: 100, page: 1, orderKey: 'created_at', desc: true }).then(res => {
        this.movieList = (res.list || []).map(el => ({ name: el.name, id: el.ID, checked: false }))
      })
    },
    setStatus(checked) {
      this.ruleInfo.status = checked ? 1 : 2
    },
    goBack() {
      this.$router.back()
    },
    deleteRule() {
      Dialog.confirm({ message: '确认删除该规则？' })
        .then(() => {
          Api.deleteOrderNotifyCondition({ id: this.ruleId }).then(() => {
            this.$toast.success('删除成功')
            this.goBack()
          })
        })
        .catch(() => {})
    },
    showGplineSelect() {
      this.selectGpline = true
      this.searchText = ''
      this.selectCount = 0
      this.filterGplineList = this.gpLineList.map(item => ({
        ...item,
        checked: (this.ruleInfo.gp_line_scope || []).indexOf(item.value) !== -1,
      }))
      this.filterGplineList.forEach(item => { if (item.checked) this.selectCount++ })
    },
    gplineCheck(index) {
      this.filterGplineList[index].checked = !this.filterGplineList[index].checked
      if (this.filterGplineList[index].checked) this.selectCount++
      else this.selectCount--
    },
    searchGplineClick() {
      if (this.searchText) {
        this.filterGplineList = this.gpLineList.filter(item => item.label.indexOf(this.searchText) !== -1).map(item => ({
          ...item,
          checked: (this.ruleInfo.gp_line_scope || []).indexOf(item.value) !== -1,
        }))
      } else {
        this.filterGplineList = this.gpLineList.map(item => ({
          ...item,
          checked: (this.ruleInfo.gp_line_scope || []).indexOf(item.value) !== -1,
        }))
      }
    },
    clearGplineClick() {
      this.searchText = ''
      this.filterGplineList = this.gpLineList.map(item => ({
        ...item,
        checked: (this.ruleInfo.gp_line_scope || []).indexOf(item.value) !== -1,
      }))
    },
    resetGpline() {
      this.filterGplineList.forEach(item => { item.checked = false })
      this.selectCount = 0
    },
    saveGpline() {
      const ids = this.filterGplineList.filter(item => item.checked).map(item => item.value)
      this.ruleInfo.gp_line_scope_type = SCOPE_TYPE_INCLUDE
      this.ruleInfo.gp_line_scope = ids
      this.ruleInfo.gp_line_desc = ids.length ? `已选择${ids.length}个院线` : '不限'
      this.selectGpline = false
    },
    saveGplineExclude() {
      const ids = this.filterGplineList.filter(item => item.checked).map(item => item.value)
      this.ruleInfo.gp_line_scope_type = SCOPE_TYPE_EXCLUDE
      this.ruleInfo.gp_line_scope = ids
      this.ruleInfo.gp_line_desc = ids.length ? `已排除${ids.length}个院线` : '不限'
      this.selectGpline = false
    },
    getGplineColorClass() {
      if (!this.ruleInfo.gp_line_scope || !this.ruleInfo.gp_line_scope.length) return ''
      return this.ruleInfo.gp_line_scope_type === SCOPE_TYPE_EXCLUDE ? 'gpline-exclude' : 'gpline-include'
    },
    showProvinceSelect() {
      this.selectProvince = true
      this.selectCount = 0
      const cur = this.ruleInfo.province_scope || []
      this.filterProvinceList = this.provinceList.map(item => ({
        ...item,
        checked: cur.indexOf(item.value) !== -1,
      }))
      this.filterProvinceList.forEach(item => { if (item.checked) this.selectCount++ })
    },
    provinceCheck(index) {
      this.filterProvinceList[index].checked = !this.filterProvinceList[index].checked
      if (this.filterProvinceList[index].checked) this.selectCount++
      else this.selectCount--
    },
    resetProvince() {
      this.filterProvinceList.forEach(item => { item.checked = false })
      this.selectCount = 0
    },
    saveProvince() {
      const ids = this.filterProvinceList.filter(item => item.checked).map(item => item.value)
      this.ruleInfo.province_scope_type = SCOPE_TYPE_INCLUDE
      this.ruleInfo.province_scope = ids
      this.ruleInfo.province_desc = ids.length ? `已包含${ids.length}个省份` : '不限'
      this.selectProvince = false
    },
    saveProvinceExclude() {
      const ids = this.filterProvinceList.filter(item => item.checked).map(item => item.value)
      this.ruleInfo.province_scope_type = SCOPE_TYPE_EXCLUDE
      this.ruleInfo.province_scope = ids
      this.ruleInfo.province_desc = ids.length ? `已排除${ids.length}个省份` : '不限'
      this.selectProvince = false
    },
    getProvinceColorClass() {
      if (!this.ruleInfo.province_scope || !this.ruleInfo.province_scope.length) return ''
      return this.ruleInfo.province_scope_type === SCOPE_TYPE_EXCLUDE ? 'province-exclude' : 'province-include'
    },
    showCitySelect() {
      this.selectCity = true
      this.searchCityText = ''
      this.searchCityCommitted = ''
      this.selectCount = 0
      const cur = (this.ruleInfo.city_scope || []).map(Number)
      this.filterCityList = (this.cityList || []).map(prov => ({
        text: prov.name,
        city_list: (prov.city_list || []).map(c => ({
          name: c.name,
          id: c.ID,
          city_code: c.city_code,
          checked: cur.includes(Number(c.city_code)),
        })),
      }))
      this.filterCityList.forEach(p => {
        (p.city_list || []).forEach(c => { if (c.checked) this.selectCount++ })
      })
    },
    toggleCity(index) {
      const list = this.filterCityList[this.activeIndex] && this.filterCityList[this.activeIndex].city_list
      if (!list || !list[index]) return
      list[index].checked = !list[index].checked
      if (list[index].checked) this.selectCount++
      else this.selectCount--
    },
    getCityItemTitle(item) {
      return item.city.name
    },
    searchCityClick() {
      const kw = (this.searchCityText || '').trim()
      this.searchCityCommitted = kw
      if (!kw) return
      this.filterCityList = [...this.filterCityList].sort((a, b) => {
        const aMatch = (a.city_list || []).some(c => (c.name || '').indexOf(kw) !== -1)
        const bMatch = (b.city_list || []).some(c => (c.name || '').indexOf(kw) !== -1)
        if (aMatch && !bMatch) return -1
        if (!aMatch && bMatch) return 1
        return 0
      })
      this.activeIndex = 0
    },
    clearCitySearch() {
      this.searchCityText = ''
      this.searchCityCommitted = ''
      const curChecked = new Set()
      this.filterCityList.forEach(p => {
        (p.city_list || []).forEach(c => { if (c.checked) curChecked.add(c.city_code) })
      })
      this.filterCityList = (this.cityList || []).map(prov => ({
        text: prov.name,
        city_list: (prov.city_list || []).map(c => ({
          name: c.name,
          id: c.ID,
          city_code: c.city_code,
          checked: curChecked.has(c.city_code),
        })),
      }))
      this.activeIndex = 0
    },
    toggleCityByItem(item) {
      const city = item.city
      city.checked = !city.checked
      if (city.checked) this.selectCount++
      else this.selectCount--
      this.activeIndex = item.provinceIndex
    },
    resetCity() {
      this.filterCityList.forEach(p => {
        (p.city_list || []).forEach(c => { c.checked = false })
      })
      this.selectCount = 0
    },
    saveCity() {
      const ids = []
      this.filterCityList.forEach(p => {
        (p.city_list || []).forEach(c => {
          if (c.checked) ids.push(Number(c.city_code))
        })
      })
      this.ruleInfo.city_scope_type = SCOPE_TYPE_INCLUDE
      this.ruleInfo.city_scope = ids
      this.ruleInfo.city_desc = ids.length ? `已包含${ids.length}个城市` : '不限'
      this.selectCity = false
    },
    saveCityExclude() {
      const ids = []
      this.filterCityList.forEach(p => {
        (p.city_list || []).forEach(c => {
          if (c.checked) ids.push(Number(c.city_code))
        })
      })
      this.ruleInfo.city_scope_type = SCOPE_TYPE_EXCLUDE
      this.ruleInfo.city_scope = ids
      this.ruleInfo.city_desc = ids.length ? `已排除${ids.length}个城市` : '不限'
      this.selectCity = false
    },
    getCityColorClass() {
      if (!this.ruleInfo.city_scope || !this.ruleInfo.city_scope.length) return ''
      return this.ruleInfo.city_scope_type === SCOPE_TYPE_EXCLUDE ? 'city-exclude' : 'city-include'
    },
    /** 构建选择影院列表：有 select_cinema 时已选影院置顶，否则沿用占位逻辑 */
    buildCinemaListWithSelectedOnTop() {
      const curIds = new Set((this.ruleInfo.cinema_scope || []).map(Number))
      const list = this.cinemaScopeListFromDetail && this.cinemaScopeListFromDetail.length > 0
        ? (() => {
            const topList = this.cinemaScopeListFromDetail.map(c => ({
              id: c.id,
              name: c.name || `影院${c.id}`,
              city_name: c.city_name || '',
              address: c.address || c.addr || '',
              checked: true,
            }))
            const restList = (this.cinemaList || []).filter(item => !curIds.has(Number(item.id))).map(item => ({ ...item, checked: false }))
            return [...topList, ...restList]
          })()
        : (() => {
            const base = (this.cinemaList || []).map(item => ({ ...item, checked: curIds.has(Number(item.id)) }))
            curIds.forEach(id => {
              if (!base.some(item => Number(item.id) === id)) {
                base.unshift({ id, name: `影院${id}`, city_name: '', address: '', checked: true })
              }
            })
            return base
          })()
      return list
    },
    showCinemaSelect() {
      this.selectCinema = true
      this.searchCinemaText = ''
      this.filterCinemaList = this.buildCinemaListWithSelectedOnTop()
      this.selectCinemaList = this.filterCinemaList.filter(item => item.checked)
      this.selectCinemaCount = this.selectCinemaList.length
    },
    toggleCinema(index) {
      this.filterCinemaList[index].checked = !this.filterCinemaList[index].checked
      if (this.filterCinemaList[index].checked) {
        this.selectCinemaList.push(this.filterCinemaList[index])
      } else {
        const i = this.selectCinemaList.findIndex(c => c.id === this.filterCinemaList[index].id)
        if (i !== -1) this.selectCinemaList.splice(i, 1)
      }
      this.selectCinemaCount = this.selectCinemaList.length
    },
    resetCinema() {
      this.filterCinemaList.forEach(item => { item.checked = false })
      this.selectCinemaList = []
      this.selectCinemaCount = 0
    },
    saveCinema() {
      const ids = this.selectCinemaList.map(c => c.id)
      this.ruleInfo.cinema_scope_type = SCOPE_TYPE_INCLUDE
      this.ruleInfo.cinema_scope = ids
      this.ruleInfo.cinema_desc = ids.length ? `已包含${ids.length}个影院` : '不限'
      this.selectCinema = false
    },
    saveCinemaExclude() {
      const ids = this.selectCinemaList.map(c => c.id)
      this.ruleInfo.cinema_scope_type = SCOPE_TYPE_EXCLUDE
      this.ruleInfo.cinema_scope = ids
      this.ruleInfo.cinema_desc = ids.length ? `已排除${ids.length}个影院` : '不限'
      this.selectCinema = false
    },
    searchCinemaClick() {
      const kw = (this.searchCinemaText || '').trim()
      const curIds = new Set((this.ruleInfo.cinema_scope || []).map(Number))
      const prevSelected = [...this.selectCinemaList]
      if (!kw) {
        this.filterCinemaList = this.buildCinemaListWithSelectedOnTop()
        this.selectCinemaList = this.filterCinemaList.filter(item => item.checked)
        this.selectCinemaCount = this.selectCinemaList.length
        return
      }
      Api.getCinemaList({ page: 1, pageSize: 200, name: kw }).then(res => {
        const list = (res.list || []).map(el => ({
          name: el.name,
          city_name: el.city_name,
          id: el.ID,
          address: el.address || el.addr || '',
          checked: curIds.has(Number(el.ID)),
        }))
        const idInList = new Set(list.map(item => Number(item.id)))
        prevSelected.forEach(item => {
          if (!idInList.has(Number(item.id))) {
            list.unshift({ ...item, checked: true })
          }
        })
        this.filterCinemaList = list
        this.selectCinemaList = this.filterCinemaList.filter(item => item.checked)
        this.selectCinemaCount = this.selectCinemaList.length
      })
    },
    clearCinemaSearch() {
      this.searchCinemaText = ''
      this.filterCinemaList = this.buildCinemaListWithSelectedOnTop()
      this.selectCinemaList = this.filterCinemaList.filter(item => item.checked)
      this.selectCinemaCount = this.selectCinemaList.length
    },
    getCinemaColorClass() {
      if (!this.ruleInfo.cinema_scope || !this.ruleInfo.cinema_scope.length) return ''
      return this.ruleInfo.cinema_scope_type === SCOPE_TYPE_EXCLUDE ? 'cinema-exclude' : 'cinema-include'
    },
    showHallSelect() {
      this.selectHall = true
      this.selectCount = 0
      const cur = this.ruleInfo.hall_scope || []
      this.filterHallList = this.defaultHallList.map(item => ({
        label: item.name,
        value: item.name,
        checked: cur.indexOf(item.name) !== -1,
      }))
      this.filterHallList.forEach(item => { if (item.checked) this.selectCount++ })
    },
    hallCheck(index) {
      this.filterHallList[index].checked = !this.filterHallList[index].checked
      if (this.filterHallList[index].checked) {
        this.selectHallList.push(this.filterHallList[index].value)
        this.selectCount++
      } else {
        const i = this.selectHallList.indexOf(this.filterHallList[index].value)
        if (i !== -1) { this.selectHallList.splice(i, 1); this.selectCount-- }
      }
    },
    resetHall() {
      this.filterHallList.forEach(item => { item.checked = false })
      this.selectHallList = []
      this.selectCount = 0
    },
    saveHall() {
      const list = this.filterHallList.filter(item => item.checked).map(item => item.value)
      this.ruleInfo.hall_scope_type = SCOPE_TYPE_INCLUDE
      this.ruleInfo.hall_scope = list
      this.ruleInfo.hall_desc = list.length ? `已包含${list.length}个影厅` : '不限'
      this.selectHall = false
    },
    saveHallExclude() {
      const list = this.filterHallList.filter(item => item.checked).map(item => item.value)
      this.ruleInfo.hall_scope_type = SCOPE_TYPE_EXCLUDE
      this.ruleInfo.hall_scope = list
      this.ruleInfo.hall_desc = list.length ? `已排除${list.length}个影厅` : '不限'
      this.selectHall = false
    },
    getHallColorClass() {
      if (!this.ruleInfo.hall_scope || !this.ruleInfo.hall_scope.length) return ''
      return this.ruleInfo.hall_scope_type === SCOPE_TYPE_EXCLUDE ? 'hall-exclude' : 'hall-include'
    },
    showMovieSelect() {
      this.selectMovie = true
      this.selectCount = 0
      const cur = this.ruleInfo.movie_scope || []
      this.filterMovieList = this.movieList.map(item => ({
        label: item.name,
        value: item.id,
        checked: cur.indexOf(item.id) !== -1,
      }))
      this.filterMovieList.forEach(item => { if (item.checked) this.selectCount++ })
    },
    movieCheck(index) {
      this.filterMovieList[index].checked = !this.filterMovieList[index].checked
      if (this.filterMovieList[index].checked) {
        this.selectCount++
      } else {
        this.selectCount--
      }
    },
    resetMovie() {
      this.filterMovieList.forEach(item => { item.checked = false })
      this.selectCount = 0
    },
    saveMovie() {
      const ids = this.filterMovieList.filter(item => item.checked).map(item => item.value)
      this.ruleInfo.movie_scope_type = SCOPE_TYPE_INCLUDE
      this.ruleInfo.movie_scope = ids
      this.ruleInfo.movie_desc = ids.length ? `已包含${ids.length}个电影` : '不限'
      this.selectMovie = false
    },
    saveMovieExclude() {
      const ids = this.filterMovieList.filter(item => item.checked).map(item => item.value)
      this.ruleInfo.movie_scope_type = SCOPE_TYPE_EXCLUDE
      this.ruleInfo.movie_scope = ids
      this.ruleInfo.movie_desc = ids.length ? `已排除${ids.length}个电影` : '不限'
      this.selectMovie = false
    },
    searchMovieClick() {
      const kw = (this.searchText || '').trim()
      if (!kw) {
        this.filterMovieList = this.movieList.map(item => ({
          label: item.name,
          value: item.id,
          checked: (this.ruleInfo.movie_scope || []).indexOf(item.id) !== -1,
        }))
      } else {
        this.filterMovieList = this.movieList.filter(item => item.name.indexOf(kw) !== -1).map(item => ({
          label: item.name,
          value: item.id,
          checked: (this.ruleInfo.movie_scope || []).indexOf(item.id) !== -1,
        }))
      }
    },
    getMovieColorClass() {
      if (!this.ruleInfo.movie_scope || !this.ruleInfo.movie_scope.length) return ''
      return this.ruleInfo.movie_scope_type === SCOPE_TYPE_EXCLUDE ? 'movie-exclude' : 'movie-include'
    },
    showWeekSelect() {
      this.selectWeek = true
      this.selectCount = 0
      const cur = this.ruleInfo.week_days || []
      this.filterWeekList = this.weekList.map(item => ({
        name: item.label,
        id: item.id,
        checked: cur.indexOf(item.label) !== -1,
      }))
      this.filterWeekList.forEach(item => { if (item.checked) this.selectCount++ })
    },
    weekCheck(index) {
      this.filterWeekList[index].checked = !this.filterWeekList[index].checked
      if (this.filterWeekList[index].checked) this.selectCount++
      else this.selectCount--
    },
    saveWeek() {
      const names = this.filterWeekList.filter(item => item.checked).map(item => item.name)
      this.ruleInfo.week_days = names
      this.ruleInfo.week_desc = names.length ? names.join('、') : '设置包含星期'
      this.selectWeek = false
    },
    showSelectedGplineList() {
      this.selectedListTitle = '已选院线'
      this.selectedListItems = this.filterGplineList.filter(i => i.checked).map(i => ({ text: i.label }))
      this.showSelectedList = true
    },
    showSelectedProvinceList() {
      this.selectedListTitle = '已选省份'
      this.selectedListItems = this.filterProvinceList.filter(i => i.checked).map(i => ({ text: i.label }))
      this.showSelectedList = true
    },
    showSelectedCityList() {
      this.selectedListTitle = '已选城市'
      const items = []
      this.filterCityList.forEach(prov => {
        (prov.city_list || []).forEach(c => {
          if (c.checked) items.push({ text: c.name, sub: prov.text ? `${prov.text}` : '' })
        })
      })
      this.selectedListItems = items
      this.showSelectedList = true
    },
    showSelectedCinemaList() {
      this.selectedListTitle = '已选影院'
      this.selectedListItems = (this.selectCinemaList || []).map(i => ({
        text: (i.city_name ? i.city_name + ' · ' : '') + i.name,
        sub: i.address || '',
      }))
      this.showSelectedList = true
    },
    showSelectedHallList() {
      this.selectedListTitle = '已选影厅'
      this.selectedListItems = this.filterHallList.filter(i => i.checked).map(i => ({ text: i.label }))
      this.showSelectedList = true
    },
    showSelectedMovieList() {
      this.selectedListTitle = '已选电影'
      this.selectedListItems = this.filterMovieList.filter(i => i.checked).map(i => ({ text: i.label }))
      this.showSelectedList = true
    },
    showSelectedWeekList() {
      this.selectedListTitle = '已选星期'
      this.selectedListItems = this.filterWeekList.filter(i => i.checked).map(i => ({ text: i.name }))
      this.showSelectedList = true
    },
    changeDate(from) {
      this.selectDate = true
      this.src = from
      const str = from === 1 ? this.ruleInfo.begin_date : this.ruleInfo.end_date
      this.currentDate = str ? new Date(str.replace(/\//g, '-')) : new Date()
    },
    dateCheck(value) {
      const date = this.formatDate(value)
      if (this.src === 1) this.ruleInfo.begin_date = date
      else this.ruleInfo.end_date = date
      this.selectDate = false
    },
    formatDate(date) {
      const y = date.getFullYear()
      const m = (date.getMonth() + 1).toString().padStart(2, '0')
      const d = date.getDate().toString().padStart(2, '0')
      return `${y}/${m}/${d}`
    },
    changeTime(from) {
      this.selectTime = true
      this.src = from
      this.currentTime = from === 1 ? (this.ruleInfo.begin_time || '00:00') : (this.ruleInfo.end_time || '23:59')
    },
    timeCheck(value) {
      if (this.src === 1) this.ruleInfo.begin_time = value
      else this.ruleInfo.end_time = value
      this.selectTime = false
    },
    lastClick(val) {
      this.lastChecked = val
    },
    handleTicketCountChange(value) {
      if (!this.inited) {
        this.inited = true
        return
      }
      if (this.lastChecked === 0) {
        if (!(value.length === 1 && value[0] === 0)) {
          this.ruleInfo.ticket_num = [0]
        }
        return
      }
      if (this.lastChecked !== 0 && value.includes(0)) {
        const filtered = value.filter(v => v !== 0)
        this.ruleInfo.ticket_num = filtered
        return
      }
      if (value.length === 0) {
        this.ruleInfo.ticket_num = [0]
        return
      }
      this.ruleInfo.ticket_num = value
    },
    saveRule() {
      if (!(this.ruleInfo.name || '').trim()) {
        this.$toast.fail('请输入规则名称')
        return
      }
      const ticketCountList = (this.ruleInfo.ticket_num || []).filter(x => x !== 0)
      if ((this.ruleInfo.ticket_num || []).includes(0) && ticketCountList.length === 0) {
        ticketCountList.push(0)
      }
      const gpLine = this.ruleInfo.gp_line_scope || []
      const province = this.ruleInfo.province_scope || []
      const city = this.ruleInfo.city_scope || []
      const cinema = this.ruleInfo.cinema_scope || []
      const hall = this.ruleInfo.hall_scope || []
      const movie = this.ruleInfo.movie_scope || []
      const payload = {
        name: this.ruleInfo.name.trim(),
        status: this.ruleInfo.status,
        gp_line_scope_type: gpLine.length ? this.ruleInfo.gp_line_scope_type : SCOPE_TYPE_ALL,
        gp_line_scope: gpLine,
        province_scope_type: province.length ? this.ruleInfo.province_scope_type : SCOPE_TYPE_ALL,
        province_scope: province,
        city_scope_type: city.length ? this.ruleInfo.city_scope_type : SCOPE_TYPE_ALL,
        city_scope: city,
        cinema_scope_type: cinema.length ? this.ruleInfo.cinema_scope_type : SCOPE_TYPE_ALL,
        cinema_scope: cinema,
        hall_scope_type: hall.length ? this.ruleInfo.hall_scope_type : SCOPE_TYPE_ALL,
        hall_scope: hall,
        movie_scope_type: movie.length ? this.ruleInfo.movie_scope_type : SCOPE_TYPE_ALL,
        movie_scope: movie,
        date_scope: [this.ruleInfo.begin_date || '', this.ruleInfo.end_date || ''],
        time_scope: [this.ruleInfo.begin_time || '', this.ruleInfo.end_time || ''],
        week_days: this.ruleInfo.week_days || [],
        seat_tag: this.ruleInfo.seat_tag || '1',
        ticket_count_list: (ticketCountList.length ? ticketCountList : [0]).map(Number),
      }
      if (this.ruleId) {
        payload.id = this.ruleId
        Api.updateOrderNotifyCondition(payload).then(() => {
          this.$toast.success('保存成功')
          this.goBack()
        })
      } else {
        Api.addOrderNotifyCondition(payload).then(() => {
          this.$toast.success('保存成功')
          this.goBack()
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.new-order-notify-rule {
  min-height: 100vh;
  background: #f5f6f8;
  padding-bottom: env(safe-area-inset-bottom, 0);
}

.page-body {
  padding: 20px 12px 40px;
  padding-bottom: calc(40px + env(safe-area-inset-bottom, 0));
}

.section-title {
  font-size: 12px;
  color: #969799;
  margin: 14px 0 8px;
  padding-left: 2px;
  font-weight: 500;
  letter-spacing: 0.3px;
}

.card-section {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.first-section {
  margin-top: 0;
}

.card-section ::v-deep .van-cell {
  padding: 12px 16px;
  font-size: 14px;
}

.card-section ::v-deep .van-cell::after {
  border-color: #f0f0f0;
}

.form-cell {
  align-items: center;
}

.cell-label {
  font-weight: 600;
  color: #323233;
  font-size: 14px;
}

.cell-required {
  color: #ee0a24;
  margin-left: 2px;
}

.cell-input ::v-deep .van-field__control {
  text-align: right;
  font-size: 14px;
}

.custom-cell .van-cell__value {
  min-width: 70%;
}

.range-cell.van-cell {
  align-items: center;
}

.range-cell ::v-deep .van-cell__title {
  flex: 0 0 auto;
  max-width: 72px;
  margin-right: 8px;
  padding-right: 0;
}

.range-cell ::v-deep .van-cell__value {
  flex: 1;
  min-width: 0;
  padding-left: 0;
}

.range-row {
  display: flex;
  align-items: center;
  width: 100%;
}

.range-field {
  flex: 1;
  min-width: 150px;
}
.range-field ::v-deep .van-field__body {
  min-width: 0;
  flex: 1;
}
.range-field ::v-deep .van-field__control {
  border: 1px solid #ebedf0;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 14px;
  min-width: 100%;
  width: 100%;
  box-sizing: border-box;
}

.range-sep {
  width: 12px;
  flex-shrink: 0;
  border-top: 1px solid #dcdee0;
}

.ticket-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 8px;
}

.ticket-opt {
  margin: 0;
}

.seat-radio-group {
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
  font-size: 13px;
}

.seat-radio-group .van-radio {
  margin: 0;
  flex-shrink: 0;
}

/* 其他条件：label 与内容间隙缩小 */
.other-condition-section ::v-deep .van-cell__title {
  flex: 0 0 auto;
  max-width: 72px;
  margin-right: 12px;
  padding-right: 0;
}

.other-condition-section ::v-deep .van-cell__value {
  flex: 1;
  min-width: 0;
  padding-left: 0;
}

/* 其他条件：内容区统一右对齐，开关/选项靠最右侧 */
.other-condition-section ::v-deep .van-cell__value {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.other-condition-section .ticket-count-cell ::v-deep .van-cell__value .van-checkbox-group,
.other-condition-section .couple-seat-cell ::v-deep .van-cell__value .van-radio-group,
.other-condition-section .status-cell ::v-deep .van-cell__value .van-switch {
  flex-shrink: 0;
}
/* 启动状态：开关放在默认插槽（value 区），与票数/情侣座一致，靠右由上方 .van-cell__value 的 justify-content: flex-end 统一保证 */

.save-wrap {
  padding: 32px 0 0;
}

.save-btn {
  height: 44px;
  font-size: 16px;
  font-weight: 500;
}

/* 弹窗底部栏 */
.popup-bottom {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f7f8fa;
  border-top: 1px solid #ebedf0;
  font-size: 13px;
}

.popup-bottom-count {
  color: #646566;
  em {
    color: #ee0a24;
    font-style: normal;
    font-weight: 600;
  }
  em.count-link {
    text-decoration: underline;
    cursor: pointer;
  }
}
.selected-list-popup .selected-list-wrap {
  max-height: 60vh;
  overflow-y: auto;
  padding: 0 0 20px;
}
.selected-list-popup .van-cell {
  font-size: 14px;
}
.selected-list-empty {
  padding: 24px;
  text-align: center;
  color: #969799;
  font-size: 14px;
}

.popup-bottom-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 弹窗通用：标题区、列表区 */
.popup-header {
  padding: 12px 16px;
  background: #f7f8fa;
  border-bottom: 1px solid #ebedf0;
}
.popup-title {
  font-size: 16px;
  font-weight: 600;
  color: #323233;
}
.popup-list-wrap {
  max-height: 320px;
  overflow-y: auto;
  padding-bottom: 0;
}
.province-popup .popup-list-wrap ::v-deep .van-cell {
  padding: 10px 16px;
  font-size: 14px;
}
.province-popup .popup-list-wrap ::v-deep .van-cell::after,
.hall-popup .popup-list-wrap ::v-deep .van-cell::after {
  left: 16px;
  right: 16px;
  border-color: #f0f0f0;
}
.hall-popup .popup-list-wrap ::v-deep .van-cell {
  padding: 10px 16px;
  font-size: 14px;
}

/* 影院弹窗：搜索框与右侧按钮美化 */
.cinema-popup-search {
  padding: 6px 16px 8px;
  background: #f7f8fa;
}
.cinema-popup-search ::v-deep .van-cell {
  padding: 0;
  background: transparent;
  border-radius: 8px;
  align-items: center;
}
.cinema-popup-search ::v-deep .van-field__body {
  padding: 4px 10px;
  min-height: 28px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebedf0;
}
.cinema-popup-search ::v-deep .van-field__control {
  font-size: 14px;
  line-height: 20px;
}
.cinema-search-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 4px;
}
.cinema-search-actions .van-icon {
  padding: 2px;
  color: #969799;
  font-size: 16px;
}
.cinema-search-actions .van-button {
  min-width: 52px;
  height: 28px;
  padding: 0 12px;
  font-size: 13px;
  line-height: 28px;
  border-radius: 14px;
}
.cinema-list-wrap {
  max-height: 400px;
  overflow-y: auto;
  padding: 0 0 10px;
}
/* 影院弹窗：内容区 flex 撑满，列表居中伸缩，底部栏贴底无留白 */
.cinema-popup.van-popup {
  padding-bottom: 0 !important;
}
.cinema-popup-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.cinema-popup .popup-header,
.cinema-popup .cinema-popup-search {
  flex-shrink: 0;
}
.cinema-popup .cinema-list-wrap {
  flex: 1;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
}
.cinema-popup .popup-bottom {
  flex-shrink: 0;
  padding-bottom: calc(12px + env(safe-area-inset-bottom, 0));
}

/* 城市弹窗：搜索框与右侧按钮美化 */
.city-popup-search {
  padding: 6px 16px 8px;
  background: #f7f8fa;
}
.city-popup-search ::v-deep .van-cell {
  padding: 0;
  background: transparent;
  border-radius: 8px;
  align-items: center;
}
.city-popup-search ::v-deep .van-field__body {
  padding: 4px 10px;
  min-height: 28px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebedf0;
}
.city-popup-search ::v-deep .van-field__control {
  font-size: 14px;
  line-height: 20px;
}
.city-search-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-left: 4px;
}
.city-search-actions .van-icon {
  padding: 2px;
  color: #969799;
  font-size: 16px;
}
.city-search-actions .van-button {
  min-width: 52px;
  height: 28px;
  padding: 0 12px;
  font-size: 13px;
  line-height: 28px;
  border-radius: 14px;
}
.city-popup-tree {
  padding-bottom: 0 !important;
}
.city-popup-tree ::v-deep .van-tree-select__nav-item {
  padding: 8px 12px;
}
.city-popup-tree .city-select-row {
  margin-bottom: 4px;
  background-color: #fff;
}
.city-popup-tree .city-select-row ::v-deep .van-cell {
  padding: 8px 16px;
}

.custom-checkbox {
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  display: inline-block;
  line-height: 1.5;
  font-size: 14px;
}

.custom-checkbox.checked {
  color: #1989fa;
  background-color: #ecf5ff;
  border-color: #1989fa;
}

/* 筛选：包含=绿色，排除=红色 */
.card-section .gpline-include,
.card-section .province-include,
.card-section .city-include,
.card-section .cinema-include,
.card-section .hall-include,
.card-section .movie-include {
  color: #07c160;
}
.card-section .gpline-include ::v-deep .van-cell__value,
.card-section .province-include ::v-deep .van-cell__value,
.card-section .city-include ::v-deep .van-cell__value,
.card-section .cinema-include ::v-deep .van-cell__value,
.card-section .hall-include ::v-deep .van-cell__value,
.card-section .movie-include ::v-deep .van-cell__value {
  color: #07c160;
}

.card-section .gpline-exclude,
.card-section .province-exclude,
.card-section .city-exclude,
.card-section .cinema-exclude,
.card-section .hall-exclude,
.card-section .movie-exclude {
  color: #ee0a24;
}
.card-section .gpline-exclude ::v-deep .van-cell__value,
.card-section .province-exclude ::v-deep .van-cell__value,
.card-section .city-exclude ::v-deep .van-cell__value,
.card-section .cinema-exclude ::v-deep .van-cell__value,
.card-section .hall-exclude ::v-deep .van-cell__value,
.card-section .movie-exclude ::v-deep .van-cell__value {
  color: #ee0a24;
}
</style>
